/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { HiOutlineSearch, HiOutlineDocument } from "react-icons/hi";
import { BiCameraMovie } from "react-icons/bi";
import { SiHotelsdotcom } from "react-icons/si";
import { Card } from "../../component/CardUtils";
import { BsBook, BsPeople } from "react-icons/bs";
import { VscFileSubmodule } from "react-icons/vsc";
import { AiOutlineShopping } from "react-icons/ai";
import { TableStatistics } from "../dashboard/DashBoard";
import { GrAttraction, GrRestaurant } from "react-icons/gr";
import { GiTheater, GiBallerinaShoes } from "react-icons/gi";
import { pushLevel } from "../../../../middlewares";
import { addOneLevel } from "../../../../middlewares/breadCrumb/BreadCrumb";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import { useDashboardContext } from "../../../../context/dashboard/context/DashboardContext";
import {
  MdShop,
  MdMusicNote,
  MdOutlineMuseum,
  MdOutlineFoodBank,
  MdOutlineNightlight,
  MdOutlineHotelClass,
  MdOutlineFormatPaint,
  MdOutlineMapsHomeWork,
} from "react-icons/md";
import { _TYPES_ } from "../../../doseeData/utils/types";
import { getType } from "../contentStats/helper";

const AllCountriesDashboard = () => {
  const { sysAdmin, setSingleAdmin } = useAdminContext();
  const { stats, fetchData } = useDashboardContext();

  // UI-only state (does not affect your data/navigation logic)
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("All"); // All | Geography | Content
  const [sort, setSort] = useState("alpha"); // alpha | count

  useEffect(() => {
    if (!stats) fetchData();
  }, [stats]);

  // Source list (unchanged)
  const List = [
    { name: "regions", quantity: stats ? stats?.continent_region : "-", route: "/region/manage" },
    { name: "countries", quantity: stats ? stats?.country : "-", route: "/countries" },
    { name: "First Level", quantity: stats ? stats?.first_level : "-", route: "/levels/first" },
    { name: "Second Level", quantity: stats ? stats?.second_level : "-", route: "/levels/second" },
    { name: "Third Level", quantity: stats ? stats?.third_level : "-", route: "/levels/third" },
    { name: "Fourth Level", quantity: stats ? stats?.fourth_level : "-", route: "/levels/fourth" },

    { name: "events", quantity: stats ? stats?.event : "-", route: "/data/event", key: _TYPES_.EVENT },
    { name: "attractions", quantity: stats ? stats?.attraction : "-", route: "/data/attraction", key: _TYPES_.ATTRACTION },
    { name: "restaurants", quantity: stats ? stats?.restaurant : "-", route: "/data/restaurant", key: _TYPES_.RESTAURANT },
    { name: "best of africa", quantity: stats ? stats?.best_of_africa : "-", route: "/data/bestofafrica", key: _TYPES_.BESTOFAFRICA },
    { name: "music", quantity: stats ? stats?.music : "-", route: "/data/music", key: _TYPES_.MUSIC },
    { name: "news", quantity: stats ? stats?.news : "-", route: "/data/news", key: _TYPES_.NEWS },
    { name: "safaris", quantity: stats ? stats?.safari : "-", route: "/data/safari", key: _TYPES_.SAFARI },
    { name: "tour packages", quantity: stats ? stats?.tour_package : "-", route: "/data/tour/package", key: _TYPES_.TOURPACKAGE },
    { name: "cinema", quantity: stats ? stats?.cinema : "-", route: "/data/cinema", key: _TYPES_.CINEMA },
    { name: "museums", quantity: stats ? stats?.museum : "-", route: "/data/museum", key: _TYPES_.MUSEUM },
    { name: "night life", quantity: stats ? stats?.nightlife : "-", route: "/data/nightlife", key: _TYPES_.NIGHTLIFE },
    { name: "hotels", quantity: stats ? stats?.hotel : "-", route: "/data/hotel", key: _TYPES_.HOTEL },
    { name: "classes", quantity: stats ? stats?.class : "-", route: "/data/class", key: _TYPES_.CLASSES },
    { name: "shopping", quantity: stats ? stats?.shopping : "-", route: "/data/shopping", key: _TYPES_.SHOPPING },
    { name: "food", quantity: stats ? stats?.food : "-", route: "/data/food", key: _TYPES_.FOOD },
    { name: "books", quantity: stats ? stats?.book : "-", route: "/data/book", key: _TYPES_.BOOK },
    { name: "neighborhoods", quantity: stats ? stats?.neighborhood : "-", route: "/data/neighborhood", key: _TYPES_.NEIGHBORHOOD },
    { name: "arts", quantity: stats ? stats?.art : "-", route: "/data/art", key: _TYPES_.ART },
    { name: "dance", quantity: stats ? stats?.dance : "-", route: "/data/dance", key: _TYPES_.DANCE },
    { name: "theaters", quantity: stats ? stats?.theater : "-", route: "/data/theater", key: _TYPES_.THEATER },
    { name: "City Guides", quantity: stats ? stats?.city_guide : "-", route: "/data/city/guide", key: _TYPES_.CITYGUIDE },
    { name: "Parties", quantity: stats ? stats?.party : "-", route: "/data/party", key: _TYPES_.PARTY },
    { name: "Things To Do", quantity: stats ? stats?.things_to_do : "-", route: "/data/things/todo", key: _TYPES_.THINGSTODO },
    { name: "Tips And Advice", quantity: stats ? stats?.tips_and_advice : "-", route: "/data/tips/advice", key: _TYPES_.TIPSANDADVICE },
    { name: "Ministries", quantity: stats ? stats?.ministry : "-", route: "/data/ministry", key: _TYPES_.MINISTRY },
    { name: "Movies", quantity: stats ? stats?.movie : "-", route: "/data/movie", key: _TYPES_.MOVIE },
    { name: "Getting Around", quantity: stats ? stats?.getting_around : "-", route: "/data/get/around", key: _TYPES_.GETTINGAROUND },
    { name: "Products", quantity: stats ? stats?.product : "-", route: "/data/product", key: _TYPES_.PRODUCT },
  ];

  // Stable icon mapping by lower-cased name (avoids index issues when filtering)
  const ICONS = {
    "regions": <MdOutlineMapsHomeWork />,
    "countries": <MdOutlineMapsHomeWork />,
    "first level": <MdOutlineMapsHomeWork />,
    "second level": <MdOutlineMapsHomeWork />,
    "third level": <MdOutlineMapsHomeWork />,
    "fourth level": <MdOutlineMapsHomeWork />,

    "events": <VscFileSubmodule />,
    "attractions": <GrAttraction />,
    "restaurants": <GrRestaurant />,
    "best of africa": <MdOutlineHotelClass />,
    "music": <MdMusicNote />,
    "news": <BsBook />,
    "safaris": <MdOutlineMuseum />,
    "tour packages": <GrAttraction />,
    "cinema": <BiCameraMovie />,
    "museums": <MdOutlineMuseum />,
    "night life": <MdOutlineNightlight />,
    "hotels": <SiHotelsdotcom />,
    "classes": <MdOutlineHotelClass />,
    "shopping": <AiOutlineShopping />,
    "food": <MdOutlineFoodBank />,
    "books": <BsBook />,
    "neighborhoods": <BsPeople />,
    "arts": <MdOutlineFormatPaint />,
    "dance": <GiBallerinaShoes />,
    "theaters": <GiTheater />,
    "city guides": <GrAttraction />,
    "parties": <BsBook />,
    "things to do": <HiOutlineDocument />,
    "tips and advice": <BsBook />,
    "ministries": <MdOutlineMapsHomeWork />,
    "movies": <GiTheater />,
    "getting around": <MdOutlineMapsHomeWork />,
    "products": <MdShop />,
  };

  const normalize = (s = "") => String(s).toLowerCase();

  const geographySet = useMemo(
    () =>
      new Set([
        "regions",
        "countries",
        "first level",
        "second level",
        "third level",
        "fourth level",
      ]),
    []
  );

  // Client-side filter/sort (UI only)
  const filtered = useMemo(() => {
    const q = normalize(query);
    let arr = List.filter((item) => {
      const byQuery = !q || normalize(item.name).includes(q);
      const isGeo = geographySet.has(normalize(item.name));
      const byCategory =
        category === "All" ? true : category === "Geography" ? isGeo : !isGeo;
      return byQuery && byCategory;
    });

    if (sort === "alpha") {
      arr = arr.slice().sort((a, b) => normalize(a.name).localeCompare(normalize(b.name)));
    } else if (sort === "count") {
      arr = arr
        .slice()
        .sort((a, b) => (Number(b.quantity) || 0) - (Number(a.quantity) || 0));
    }
    return arr;
  }, [List, query, category, sort, geographySet]);

  const geoCards = filtered.filter((i) => geographySet.has(normalize(i.name)));
  const contentCards = filtered.filter((i) => !geographySet.has(normalize(i.name)));

  const total = List.length;
  const shown = filtered.length;

  return (
    <div className="overflow-y-auto p-3 lg:p-4 h-full rounded-b-xl bg-gray-50">
      {/* Toolbar */}
      <div className="mx-auto mb-4 max-w-7xl">
        <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div>
              <h2 className="text-sm font-semibold tracking-tight text-gray-900">
                All Countries – Content Library
              </h2>
              <p className="mt-1 text-[11px] text-gray-600">
                Quick access to geography and core content. Use filters to narrow down.
              </p>
            </div>

            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              {/* Search */}
              <div className="relative">
                <span className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-gray-500">
                  <HiOutlineSearch className="h-4 w-4" />
                </span>
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search categories…"
                  className="w-full rounded-lg border border-gray-200 bg-white pl-8 pr-8 py-2.5 text-xs focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200 md:min-w-[280px]"
                />
                {!!query && (
                  <button
                    type="button"
                    aria-label="Clear search"
                    onClick={() => setQuery("")}
                    className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md bg-gray-100 px-1.5 text-[10px] font-semibold text-gray-700 hover:bg-gray-200"
                  >
                    Clear
                  </button>
                )}
              </div>

              {/* Category chips */}
              <div className="flex gap-1">
                {["All", "Geography", "Content"].map((c) => (
                  <button
                    key={c}
                    onClick={() => setCategory(c)}
                    className={`rounded-full px-3 py-1 text-[11px] font-semibold transition ${category === c
                        ? "bg-gray-900 text-white"
                        : "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                  >
                    {c}
                  </button>
                ))}
              </div>

              {/* Sort */}
              <div className="flex gap-1">
                {[
                  { k: "alpha", label: "A–Z" },
                  { k: "count", label: "By Count" },
                ].map(({ k, label }) => (
                  <button
                    key={k}
                    onClick={() => setSort(k)}
                    className={`rounded-full px-3 py-1 text-[11px] font-semibold transition ${sort === k
                        ? "bg-emerald-600 text-white"
                        : "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Meta line */}
          <div className="mt-3 flex items-center justify-between text-[11px] text-gray-500">
            <span>
              Showing <span className="font-semibold text-gray-700">{shown}</span> of {total}
            </span>
            <span className="h-[2px] w-24 rounded-full bg-gradient-to-r from-emerald-500 via-amber-500 to-purple-500 opacity-40" />
          </div>
        </div>
      </div>

      {/* Geography & Levels */}
      {category !== "Content" && (
        <section className="mx-auto max-w-7xl">
          <header className="mb-3">
            <h3 className="text-xs font-bold tracking-wide text-gray-800">GEOGRAPHY & LEVELS</h3>
            <p className="text-[11px] text-gray-500">
              Regions, countries, and hierarchical levels.
            </p>
          </header>

          {geoCards.length === 0 ? (
            <div className="rounded-xl border border-dashed border-gray-200 bg-white p-8 text-center text-xs text-gray-600 shadow-sm mb-6">
              No matches in Geography & Levels.
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4 items-center selection:text-white selection:bg-blue-900 mb-6">
              {geoCards.map((card, index) => {
                const icon = ICONS[normalize(card?.name)] || <MdOutlineMapsHomeWork />;
                return (
                  <Link
                    to={card?.route}
                    key={`geo-${card?.name}-${index}`}
                    onClick={() => {
                      if (
                        ![
                          "regions",
                          "countries",
                          "First Level",
                          "Second Level",
                          "Third Level",
                          "Fourth Level",
                        ].includes(card?.name)
                      ) {
                        setSingleAdmin({
                          ids: [sysAdmin?.admin_id],
                          type: getType({ field: card?.key }),
                          route: "/countries/dashboard",
                        });
                        addOneLevel({
                          id: 0,
                          name: `${sysAdmin?.first_name} ${sysAdmin?.last_name}`,
                          route: "/levels/first",
                          level: "",
                          country_id: 0,
                          data: {
                            data: {
                              name: "",
                              country_id: 0,
                              first_level_id: 0,
                              second_level_id: 0,
                              third_level_id: 0,
                              fourth_level_id: 0,
                              level: "",
                            },
                          },
                        });
                        pushLevel({
                          level: {
                            id: 0,
                            name: "",
                            level: "All",
                            route: "/levels/first",
                            data: null,
                          },
                        });
                      }
                    }}
                  >
                    <div className="transition-transform duration-150 ease-out hover:-translate-y-0.5">
                      <Card
                        card={{
                          name: card.name,
                          quantity: card.quantity,
                          icon,
                        }}
                      />
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </section>
      )}

      {/* Core Content */}
      {category !== "Geography" && (
        <section className="mx-auto max-w-7xl">
          <header className="mb-3">
            <h3 className="text-xs font-bold tracking-wide text-gray-800">CORE CONTENT</h3>
            <p className="text-[11px] text-gray-500">
              Primary editorial and destination content.
            </p>
          </header>

          {contentCards.length === 0 ? (
            <div className="rounded-xl border border-dashed border-gray-200 bg-white p-8 text-center text-xs text-gray-600 shadow-sm">
              No matches in Core Content.
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4 items-center selection:text-white selection:bg-blue-900">
              {contentCards.map((card, index) => {
                const icon = ICONS[normalize(card?.name)] || <MdOutlineMapsHomeWork />;
                return (
                  <Link
                    to={card?.route}
                    key={`content-${card?.name}-${index}`}
                    onClick={() => {
                      if (
                        ![
                          "regions",
                          "countries",
                          "First Level",
                          "Second Level",
                          "Third Level",
                          "Fourth Level",
                        ].includes(card?.name)
                      ) {
                        setSingleAdmin({
                          ids: [sysAdmin?.admin_id],
                          type: getType({ field: card?.key }),
                          route: "/countries/dashboard",
                        });
                        addOneLevel({
                          id: 0,
                          name: `${sysAdmin?.first_name} ${sysAdmin?.last_name}`,
                          route: "/levels/first",
                          level: "",
                          country_id: 0,
                          data: {
                            data: {
                              name: "",
                              country_id: 0,
                              first_level_id: 0,
                              second_level_id: 0,
                              third_level_id: 0,
                              fourth_level_id: 0,
                              level: "",
                            },
                          },
                        });
                        pushLevel({
                          level: {
                            id: 0,
                            name: "",
                            level: "All",
                            route: "/levels/first",
                            data: null,
                          },
                        });
                      }
                    }}
                  >
                    <div className="transition-transform duration-150 ease-out hover:-translate-y-0.5">
                      <Card
                        card={{
                          name: card.name,
                          quantity: card.quantity,
                          icon,
                        }}
                      />
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </section>
      )}

      {/* Original table preserved */}
      <div className="mx-auto max-w-7xl mt-6">
        <TableStatistics />
      </div>
    </div>
  );
};

export default AllCountriesDashboard;
